export default "__VITE_ASSET__BWefWlwj__"